module.exports = __webpack_public_path__ + "img/video-lead.d3037e36.png";